import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f767dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative page" }, null, -1))
const _hoisted_2 = { class: "logout" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-noise" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skyline-logo" }, null, -1))
const _hoisted_6 = { class: "body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", { class: "text-military-green-500" }, "Welcome to Skyline", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-normal text-rust-500" }, "Authorization", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8" }, null, -1))
const _hoisted_10 = { class: "message" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { useGlobalStore } from '../store/globalStore';
import { storeToRefs } from 'pinia';
import LoginButtonComponent from '../components/LoginButtonComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizationPage',
  setup(__props) {

const { firebaseUser, currentUser, getAuthorizationDetails } = storeToRefs(
  useGlobalStore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoginButtonComponent, {
        class: "mt-2 text-xs",
        isLoggedIn: _unref(currentUser) !== null,
        isEmailVerified: _unref(firebaseUser)?.emailVerified,
        currentUser: _unref(currentUser)
      }, null, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(getAuthorizationDetails)), 1),
        _hoisted_11
      ])
    ])
  ], 64))
}
}

})